module.exports = __webpack_public_path__ + "static/media/small_morning_star.f5c5380f.svg";